module.exports = __webpack_public_path__ + "img/ring_g_e_1_null.18fa4d69.png";